import { Typography } from '@faceup/ui-base'
import { useElementSize } from '@mantine/hooks'
import { twMerge } from 'tailwind-merge'
import { MoreInfo } from '../IconWithLogic'
import type { FormVariant } from './config'

const Form: FormVariant['form'] = ({ children }) => {
  return <div className='flex flex-col gap-4'>{children}</div>
}

const FormItem: FormVariant['item'] = ({
  children,
  label,
  hint,
  secondary,
  withAsterisk,
  errorMessage,
  formItemProps,
  notClickableLabel,
}) => {
  const { ref: secondarySizeRef, width: secondaryWidth } = useElementSize()

  const isSomethingInLabelRow = label || hint || secondary

  const wrapperClassName = twMerge('relative w-full', formItemProps?.className)

  if (!isSomethingInLabelRow) {
    return (
      <div {...formItemProps} className={wrapperClassName}>
        {children}
        {errorMessage && <Typography.Text type='danger'>{errorMessage}</Typography.Text>}
      </div>
    )
  }

  return (
    <div {...formItemProps} className={wrapperClassName}>
      {secondary && (
        <div className='absolute ltr:right-0 rtl:left-0' ref={secondarySizeRef}>
          {secondary}
        </div>
      )}
      {/* biome-ignore lint/a11y/noLabelWithoutControl: Wrapper label for form item grouping */}
      <label>
        {notClickableLabel && <input className='invisible absolute h-0 w-0' />}
        <div className={twMerge('flex flex-col', isSomethingInLabelRow && 'gap-1')}>
          <div style={{ width: `calc(100% - ${secondaryWidth}px)` }}>
            <Typography.Text strong size='small' className='text-colorTextTertiary'>
              <span
                className={twMerge(
                  errorMessage ? 'text-colorError' : 'text-colorTextTertiary',
                  'sensitive'
                )}
              >
                {label}
              </span>{' '}
              {withAsterisk && (
                <Typography.Text type='danger' size='small'>
                  *
                </Typography.Text>
              )}{' '}
              {hint && <MoreInfo title={hint} />}{' '}
            </Typography.Text>
          </div>
          {children}
        </div>
      </label>
      {errorMessage && <Typography.Text type='danger'>{errorMessage}</Typography.Text>}
    </div>
  )
}

export const defaultVariant: FormVariant = {
  form: Form,
  item: FormItem,
}
